import React from 'react';

export default function Mouse() {
	// 2
	let style = {
		st24: {
			fill:"#FC5959"
		},
		st36: {
			fill:"#987FEF"
		},
		st38: {
			fill:"#353535"
		}
	};
	return (
		<g>
			<path style={style.st24} d="M95.603653,413.375946c11.2272034-0.1366272,22.4543991-0.2733154,33.6817474-0.4099426
				c3.8037109-0.0462952,3.8060303,5.8628235,0,5.9091492c-11.2273483,0.1365967-22.4545441,0.2733154-33.6817474,0.4099121
				C91.7999344,419.3313904,91.7976303,413.4222412,95.603653,413.375946z"/>
			<path style={style.st24} d="M162.9366302,397.3920898c1.8909302-1.7072144,4.1417084-2.9072266,6.7154388-3.0761414
				c2.5509033-0.1673889,5.1995697,0.9503784,6.5992432,3.1391602c2.2511597,3.5202026,1.0830994,9.71521-3.6716766,10.4454956
				c-2.1125336,0.3244934-4.5161591-0.5332336-5.0473022-2.8658447c-0.0743256-0.3257751-0.0923615-0.6753845-0.0853577-1.0298157
				c-1.5062561,0.6325073-3.3284607,0.4774475-4.5103455-0.8100281
				C161.4960938,401.6257629,161.2352295,398.9281921,162.9366302,397.3920898z"/>
			<path style={style.st36} d="M179.3167572,415.3426514c0,0-6.2044678-19.2520752-21.9993134-19.2520752
				s-28.5991211,10.4623108-28.5991211,18.9946594c0,8.5323792,12.8042603,11.9037476,28.5991211,11.9037476
				S179.3167572,415.3426514,179.3167572,415.3426514z"/>
			<path style={style.st24} d="M149.8225555,397.4550781c1.4503632-2.1554565,4.0482941-3.3065186,6.5993042-3.1391602
				c2.5737152,0.1689453,4.8244019,1.368988,6.7154999,3.0761414l0.0395966,0.0362854
				c1.5887909,1.4562378,0.5493774,4.1047974-1.6057739,4.0917664l-0.3800201-0.0023193
				c-3.4464569,0-5.5392456,2.091095-6.2872162,4.6378174c-0.4185333,1.4251099-2.2041321,2.0195312-3.3579407,1.0842285
				C149.2863159,405.4081116,147.1723785,401.3937378,149.8225555,397.4550781z"/>
			<path style={style.st38} d="M165.7392578,413.0517578c-0.1972656,0-0.3964844-0.0581055-0.5703125-0.1791992
				c-0.453125-0.3154297-0.5654297-0.9389648-0.2490234-1.3920898l3.9775391-5.7148438
				c0.3154297-0.4536133,0.9384766-0.5649414,1.3916016-0.2495117s0.5654297,0.9389648,0.2490234,1.3920898l-3.9775391,5.7148438
				C166.3662109,412.9023438,166.0556641,413.0517578,165.7392578,413.0517578z"/>
			<path style={style.st38} d="M170.5849609,412.1835938c-0.1972656,0-0.3964844-0.0581055-0.5703125-0.1791992l-5.7148438-3.9780273
				c-0.453125-0.3154297-0.5654297-0.9389648-0.2490234-1.3920898c0.3154297-0.453125,0.9384766-0.5654297,1.3916016-0.2495117
				l5.7148438,3.9780273c0.453125,0.3154297,0.5654297,0.9389648,0.2490234,1.3920898
				C171.2119141,412.0341797,170.9013672,412.1835938,170.5849609,412.1835938z"/>
			<path style={style.st24} d="M178.5570526,411.8014526c2.9827118,0,2.9827118,4.9711609,0,4.9711609
				C174.5801239,416.7726135,174.5801239,411.8014526,178.5570526,411.8014526z"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Mouse.js